import React, { useEffect } from "react";

import { BrowserRouter, Routes, Route } from "react-router";
import Login from "../pages/Login";
import OTP from "../pages/OTP";
import Dashboard from "../components/Dashboard";
import Leads from "../components/Leads";
import AddEditLeads from "../components/AddEditLeads";
import AssignmentLogs from "../components/AssignmentLogs";
import Loader from "../components/Loader";
import { Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { pathOr } from "ramda";
import { HIDE_SNACK } from "../actions/types";
import AddLeads from "../components/AddLeads";



const AppRouter = () => {
    const loader = useSelector(state => pathOr(false,['Loader','loader'],state))
    const open =useSelector(state => state.Snack.open)
    const error = useSelector(state => state.Snack.error)
      const dispatch = useDispatch()
    useEffect(() => {
      setTimeout(() => {
        dispatch({
          type: HIDE_SNACK
        })
      },6000)
    },[open])
    return (
        <>
<Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}>
        <CircularProgress color="inherit" />
       </Backdrop>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/otp" element={<OTP />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/viewleads/:id" element={<AddEditLeads />} />
                <Route path="/addleads" element={<AddLeads />} />
                <Route path="/editLead/:id" element={<AddLeads />} />
                <Route path="/assignmentlogs" element={<AssignmentLogs />} />
            </Routes>
        </BrowserRouter>
        <Snackbar
          anchorOrigin={{ vertical:'bottom', horizontal: 'center' }}
          open={open}
          message={error}
        />
        </>
    )
}

export default AppRouter;